import noop from 'lodash/noop'
import { forwardRef } from 'react'
import styled from 'styled-components'
import { colors, transitions, fontSizes, fontWeights } from '@/styles'
import { toUnit } from '@/utils/styles'

const Wrapper = styled.div`
  height: ${props => toUnit(props.height) || '100px'};
  width: 100%;
  max-width: 100%;
  position: relative;
  margin-top: ${props => props.top || 0}px;
`

const Control = styled.textarea`
  border-radius: 6px;
  padding: 8px;
  height: 100%;
  border-radius: ${props => (props.radius ? toUnit(props.radius) : '6px')};
  border: ${props =>
    props.border
      ? props.border
      : props.showErrorBorder
      ? `1.5px solid ${colors.red64}`
      : `1.5px solid ${colors.grey88}`};
  font-size: ${props => (props.fontSize ? `${props.fontSize}px` : fontSizes.regular)};
  font-weight: ${props => props.fontWeight || fontWeights.regular};
  outline: none;
  color: ${colors.black};
  width: 100%;
  resize: none;
  background: ${props => props.background || colors.white};
  transition: ${transitions.borderColor};

  &::placeholder {
    color: ${colors.grey56};
    font-weight: ${fontWeights.regular};
  }
  &:focus {
    border-color: ${props => (props.showErrorBorder ? colors.red64 : colors.secondary)};
  }
  &:disabled {
    opacity: 0.3;
  }
`

const Counter = styled.small`
  position: absolute;
  color: ${props => (props.showError ? colors.red64 : colors.black)};
  font-size: ${fontSizes.small};
  line-height: 22px;
  text-align: right;
  right: 5px;
  bottom: 0px;
`

// This "legacy" textarea is needed for the chat quick reply modal
// inputs since they use a totally different expandable text area
// that isn't compatible with the new textarea component:
// src/features/Chat/chat-room/quick-reply/expandable-text-area.jsx
const TextareaLegacy = forwardRef(
  (
    {
      onChange,
      children,
      maxLength,
      border,
      value = '',
      setTextArea = noop,
      showErrorBorder,
      ...rest
    },
    ref
  ) => {
    const handleChange = e => {
      // eslint-disable-next-line no-param-reassign
      if (maxLength) e.target.value = e.target.value.slice(0, maxLength)
      onChange(e)
    }
    return (
      <Wrapper ref={ref} top={rest.top} height={rest.height} background={rest.background}>
        <Control
          {...rest}
          showErrorBorder={showErrorBorder}
          value={value}
          border={border}
          onChange={handleChange}
          ref={textRef => setTextArea(textRef)}
        >
          {children}
        </Control>
        {maxLength && (
          <Counter showError={showErrorBorder}>
            {value?.length}/{maxLength}
          </Counter>
        )}
      </Wrapper>
    )
  }
)

TextareaLegacy.displayName = 'TextareaLegacy'

export default TextareaLegacy
